<template>

    <h3>O mně</h3>
  <p>Jmenuji se Zdenka Cihlářová a pomáhám lidem a jejich psům, aby žili spokojenější život. Spolu. Aby nemuseli bojovat jeden s&nbsp;druhým, aby našli společnou cestu i&nbsp;řeč.</p>
  <p>Pracuji především technikou pozitivního posilování.</p>

  <h5>Praxe</h5>
    <p>Jako trenéra mě můžete potkávat v&nbsp;posledních letech v oblasti mezi&nbsp;Mladou Boleslaví, Jičínem a Nymburkem na&nbsp;individuálních lekcích, kurzech, socializačních i tréninkových vycházkách. Od&nbsp;roku 2022 pak trénuji i pod&nbsp;hlavičkou 
      <a href="https://zkonymburk.blogspot.com/" target="_blank">ZKO Nymburk</a>. A od&nbsp;léta 2025 mám své kurzy i v&nbsp;Pardubicích v&nbsp;<a href="https://zkodukla.cz/" target="_blank">ZKO Dukla</a></p>
    <p>Od&nbsp;jara 2022 do jara 2025 jsem pracovala jako externí trenér pro&nbsp;<a href="https://www.dog-point.cz/" target="_blank">útulek Dogpoint</a>, kam jsem dojížděla přibližně jednou týdne a se&nbsp;psy, kteří to potřebovali, 
      pracovala na&nbsp;sebekontrole, sebevědomí, klidném chování, ošetření se souhlasem a dalších věcech, které by měl pes pro&nbsp;bezproblémové fungování v rodině znát. Případně které alespoň umožní ošetřovatelům lepší manipulaci s&nbsp;daným psem.</p>
    <p>V létě 2026 jsem začala trénovat také v Praze v <a href="https://www.hodnypes.cz/" target="_blank">tréninkovém centru Hodný pes</a>. Potkávat se můžeme na Parkovkách, poslušnostních kurzech a kurzech pro reaktivce.</p>
  
      <h5>Moji psi</h5>
  <p>Se psy žiji více než 20 let, prvního psa - cane corso Altara jsem přivedla domů v roce 2003, po&nbsp;jeho smrti v&nbsp;roce 2013 jsem poprvé adoptovala psa 
    z&nbsp;útulku a díky Adamovi začala moje honba za informacemi, co dělat a jak žít s&nbsp;dospělým, nevychovaným, vystresovaným a občas agresivním psem. 
    Dalšího útulkáče - Charlieho jsem "vyvdala" - šlo o&nbsp;nevychovance s&nbsp;nulovou sebekontrolou. V&nbsp;létě roku 2017 se s&nbsp;adopcí mladého malého teriéra Bohouška počet 
    psích členů v naší domácnosti ustálil na třech. Na podzim 2021 zemřel Adámek a do&nbsp;smečky přibyla první fenečka - hodně bojácná a citlivá Dorotka.
    Abychom se nenudili, přibyla k&nbsp;nám v lednu 2024 do&nbsp;dlouhodobé dočasné péče Olinka - bázlivá a intenzivní kříženka šarpeje s&nbsp;jezevčíkem. Na&nbsp;podzim stejného roku jsme pak přišli v požehnaném věku 15 let o&nbsp;Charlieho.
  Za&nbsp;těch několik let jsem tak měla možnost pracovat a hlavně žít s&nbsp;naprosto odlišnými povahami, historií psů i s&nbsp;jejich zátěží z&nbsp;minulosti. 
  A co je asi nejdůležitější, naučila jsem se, jak se s&nbsp;nimi dobře bavit a jak se z&nbsp;toho nezbláznit :)</p> 
  <p>Se&nbsp;svými psy jsem si během let vyzkoušela klasickou poslušnost, dogdancing, nosework, agility i hoopers a v&nbsp;některých z&nbsp;těchto odvětví splnila alespoň základní zkoušky. 
    Díky tomu mám představu, který sport by mohl bavit které psy a případně odkázat na&nbsp;trenéra onoho sportu v&nbsp;okolí.</p>
  <h5>Vzdělávání</h5>
  <h6>Vzdělávání 2026</h6>
  <p>
    <b>
      Webinář Jak mluvit se psy (1. díl) - Lenka Blachová<br>
      online kurz Psovština pro pokročilé – Lenka Blachová<br>
      série 3 webinářů - Motivace aneb Co ne/hýbe psem (Co je to motivace, Vzrušení, Tvorba regulovaného tréninku) - Lenka Blachová
    </b>
  </p>
  <h6>Vzdělávání 2025</h6>
  <p>
    <b>
      Kurz tréninku přes kontaktní bariéru – aneb „odděleni a přitom k sobě blíž“ - F. Šusta<br>
      Webinář Jak změnit „vzpomínky v hlavě“? - F. Šusta<br>
      Webinář Tajná řeč aneb „Jak ještě lépe komunikovat se svým psem“ - F. Šusta<br>
      MET konference<br>
      Webinář - Etologie, emoce, chování - Lenka Blachová<br>
      Webinář - Základní nalejvárna pro majitele reaktivce<br>
      Víkend o tréninku psů a jiných zvířat s Františkem Šustou „výběr toho nej…“ – řešení problémů - F. Šusta<br>
      Webinář - RESILIENCE aneb budování odolnosti - Lenka Blachová<br>
      Seminář - Etické otázky moderního tréninku i chovu zvířat podle Gabby Harris - Gabby Harris<br>
      Seminář - Sebepřijetí a komunikace se zvířaty podle Gabby Harris - Gabby Harris<br>
      Seminář - Intuitivní komunikace se zvířaty s Gabby Harris - Gabby Harris<br>
      Seminář - Hluboký ponor do motivace zvířat - Gabby Harris<br>
      Seminář - Tellington TTouch doteky a bandáže - Marta Mannelová<br>
    </b>

  </p>
  <h6>Vzdělávání 2024</h6>
  <p>
    <b>Webinář Konflikty mezi&nbsp;psy - Lenka Blachová <br>
    MET konference<br>
    Divák - Komunikační lekce pro&nbsp;psy s&nbsp;Lenkou Blachovou <br>
    Víkendovka s&nbsp;Alexou Capra - Koira psí škola<br></b>
    témata: Jak pracovat se&nbsp;psem na&nbsp;vodítku a jak mu pomoci, pokud se ocitne v&nbsp;problémech. Co a jakým způsobem komunikovat psu na&nbsp;vodítku<br>
    Sociální hra, sdílení, propojení se&nbsp;psem a copingové strategie<br>
    Důležitost psí schopnosti čuchat u&nbsp;přechodu ze&nbsp;systému útěk /útok do&nbsp;systému sociálního zapojení<br>
    <b>WEBINÁŘ ZVÍŘECÍ SEBEOVLÁDÁNÍ a jak ho naučit - F. Šusta<br>
    Online kurz Se&nbsp;zvuky v&nbsp;pohodě! - Markéta Rybářová<br>
    Víkend v&nbsp;Praze s&nbsp;Gabby Harris<br></b>
    témata: Etický trénink zvířat a úprava chování - smysl, metody a co všechno lze dokázat<br>
    Seberegulace člověka i zvířete v&nbsp;etickém tréninku<br>
    <b>Webinář Bolí ho to, nebo zlobí? MVDr. Dorota Lippert + MVDr. Markéta Rybářová</b>
  </p>
  <br>
  <p>Dále jsem absolventkou unikátní Akademie pro&nbsp;instruktory 2018/19 psí školy Koira. Během let jsem se účastnila seminářů Alexy Capra, mnoha komunikačních lekcí Lenky Blachové a Magdy Šimečkové, 
  mnoha teoretických seminářů a webinářů Lenky Blachové a seminářů Gaby Harris, Františka Šusty nebo webináře Elišky Šuhaj. Stále se vzdělávám ať už odbornou literaturou nebo třeba sledováním MET konferencí i účastí v&nbsp;různých výzvách s&nbsp;vlastními psy.
  Zajímá mě psí komunikace a vliv fyzického zdraví na&nbsp;chování psů.</p>

</template>
<script>
import { useMeta } from 'vue-meta'

export default {
  name: 'Home',
  components: {
    
  },

  setup () {
    useMeta({ title: 'Člověk a pes spolu - trenér psů Zdenka Cihlářová' })
  },

}
</script>

<style lang="scss">
a {
  color: $secondary
}
</style>
